const normalizeShapeType = (value) => {
  const normalized = String(value ?? '').trim().toLowerCase();
  return normalized === '7005' ? 'path' : normalized;
};
const getDescriptorText = (place) =>
  [
    place?.placeType,
    place?.zoneType,
    place?.buildingType,
    place?.name,
    place?.title,
    place?.description,
    place?.entityName,
    place?.entityTitle,
    place?.entityDesc,
  ]
    .map((value) => String(value ?? '').trim().toLowerCase())
    .filter(Boolean)
    .join(' ');

export const isRoadPathDraft = (place) => {
  if (normalizeShapeType(place?.shape?.shapeType) !== 'path') {
    return false;
  }

  const text = getDescriptorText(place);
  if (/\b(river|stream|waterway|canal|tunnel|corridor|sewer)\b/.test(text)) {
    return false;
  }

  return String(place?.placeType ?? '').trim().toLowerCase() === 'passage' ||
    /\b(road|route|highway|street|lane|trail|track|causeway|path)\b/.test(text);
};

export const applyGeneratedRouteGeometry = (place, result) => {
  if (!place || !result?.location || !result?.shape) {
    return null;
  }

  return {
    ...place,
    location: {
      ...(place.location ?? {}),
      ...result.location,
    },
    shape: {
      ...(place.shape ?? {}),
      ...result.shape,
      shapeData: {
        ...(place.shape?.shapeData ?? {}),
        ...(result.shape?.shapeData ?? {}),
      },
    },
  };
};
